import {
  ChangeDetectorRef,
  Component,
  inject,
  Input,
  OnInit,
} from '@angular/core';
import { CriteriaStoreService } from '../../services/criteria-store.service';
import { CriteriaService } from '../../services/criteria.service';
import { CriteriaResponse } from 'src/app/models/criteria.model';
import {
  DsBreadcrumbModule,
  DsLoadingAreaConfiguration,
  DsLoadingAreaModule,
  DsLoadingAreaService,
  DsSelectModule,
} from '@bmw-ds/components';

@Component({
  selector: 'app-breadcrumb',
  templateUrl: './breadcrumb.component.html',
  styleUrls: ['./breadcrumb.component.scss'],
  imports: [DsBreadcrumbModule, DsSelectModule, DsLoadingAreaModule],
  standalone: true,
})
export class BreadcrumbComponent implements OnInit {
  plantName: string = '';
  plantCode: string = '';
  loadingAreaConfig: DsLoadingAreaConfiguration = { id: 'bodyLoading' };
  @Input() externalData!: CriteriaResponse;

  private readonly criteriaStoreService = inject(CriteriaStoreService);

  private readonly criteriaService = inject(CriteriaService);
  private readonly loadingAreaService = inject(DsLoadingAreaService);
  private cdr = inject(ChangeDetectorRef);

  ngOnInit(): void {
    this.loadingAreaService.addLoadingArea(this.loadingAreaConfig);
    this.cdr.detectChanges();
    this.fetchCriteriaData();
  }

  private fetchCriteriaData(): void {
    this.criteriaStoreService.getCriteriaData().subscribe((data) => {
      if (!data) {
        const dealerCode = localStorage.getItem('dealerCode') ?? ''; // Default dealer code if not set
        if (dealerCode) {
          this.criteriaService
            .postCriteriaSelection(dealerCode)
            .subscribe((criteriaData) => {
              this.criteriaStoreService.setCriteriaData(criteriaData);
              this.mapPlantData(criteriaData);
            });
        }
      } else {
        this.mapPlantData(data);
      }
    });
  }

  private mapPlantData(data: CriteriaResponse): void {
    this.plantName = data.plantName;
    this.plantCode = data.plantCode;
    this.loadingAreaService.removeLoadingArea(this.loadingAreaConfig.id);
  }
}
